import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../core/services/auth.service';

export interface SeekerBookingItem {
  bookingId: string;
  unitId: string;
  slug: string;
  title: string;
  location: string;
  image: string;
  arrivalDate: string;
  departureDate: string;
  rentalType: string;
  status: string;
  statusLabel: string;
  price: number;
  currency: string;
  createdAt: string;
}

export interface SeekerBookingsResponse {
  bookings: SeekerBookingItem[];
}

@Injectable({ providedIn: 'root' })
export class SeekerBookingsService {
  private baseUrl = environment.api.baseUrl;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  getBookings(): Observable<SeekerBookingsResponse> {
    const token = this.authService.getAccessToken();
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    return this.http.get<SeekerBookingsResponse>(`${this.baseUrl}/seeker/bookings`, { headers });
  }
}
